var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.5C25.2956 0.5 26.0587 0.81607 26.6213 1.37868C27.1839 1.94129 27.5 2.70435 27.5 3.5V24.5C27.5 25.2956 27.1839 26.0587 26.6213 26.6213C26.0587 27.1839 25.2956 27.5 24.5 27.5H3.5C2.70435 27.5 1.94129 27.1839 1.37868 26.6213C0.81607 26.0587 0.5 25.2956 0.5 24.5V3.5C0.5 2.70435 0.81607 1.94129 1.37868 1.37868C1.94129 0.81607 2.70435 0.5 3.5 0.5H24.5ZM21.05 10.025C21.38 9.71 21.38 9.185 21.05 8.87L19.13 6.95C19.0555 6.87186 18.9659 6.80965 18.8666 6.76714C18.7673 6.72464 18.6605 6.70272 18.5525 6.70272C18.4445 6.70272 18.3377 6.72464 18.2384 6.76714C18.1391 6.80965 18.0495 6.87186 17.975 6.95L16.475 8.45L19.55 11.525L21.05 10.025ZM6.5 18.41V21.5H9.59L18.68 12.41L15.59 9.32L6.5 18.41Z",
    fill: "#5B58E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.3f41f6609fd0534e7288fe31e6b4922b.svg";
export { ForwardRef as ReactComponent };